import * as React from "react";

// Custom exclusive Home/Inicio badge icon
// - Designed to look unique compared to lucide-house
// - Works with currentColor (inherits from text-*)
// - Supports className and other SVG props
export function InicioBadgeIcon(props: React.SVGProps<SVGSVGElement>) {
  const { className, ...rest } = props;
  return (
    <img
      src="/logo-icon.svg"
      className={className}
      alt={(props as any)["aria-label"] || "Início"}
      {...rest as any}
    />
  );
}

export default InicioBadgeIcon;
